import { Component, computed, input } from '@angular/core'

import { NgIcon, provideIcons } from '@ng-icons/core'
import { lucideChevronRight } from '@ng-icons/lucide'
import { hlm } from '@spartan-ng/brain/core'

import { HlmIconDirective } from '@yoshu-lib/ui/ui-icon-helm/src'

import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-menu-item-sub-indicator',
  providers: [provideIcons({ lucideChevronRight })],
  imports: [NgIcon, HlmIconDirective],
  template: ` <ng-icon hlm size="none" class="h-full w-full" name="lucideChevronRight" /> `,
  host: {
    '[class]': '_computedClass()'
  }
})
export class HlmMenuItemSubIndicatorComponent {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected _computedClass = computed(() => hlm('inline-block ml-auto h-4 w-4', this.userClass()))
}
